import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selector as commonSelector } from '@store/common';
import { DateContainer, DateRange } from './styled';
import Shorcuts from './Shortcuts';
import CustomDateRangePicker from './CustomDateRangePicker';
import moment from 'moment';

const DatePickerV2 = ({
  selectedInterval, shortcuts, cutoffDate, setInterval,
}) => {
  const [isCustomSelected, setCustomSelected] = useState(false);
  const common = useSelector(commonSelector);
  const { tzOffset } = common;
  const containerRef: any = React.useRef();

  const dateFormat = 'YYYY/MM/DD';

  const value = useMemo(() => {
    return [moment(selectedInterval.from, dateFormat), moment(selectedInterval.to, dateFormat)]
  }, [selectedInterval]);

  return (
    <DateRange id="date-picker-v2" ref={containerRef}>
      <DateContainer>
        <Shorcuts
          shortcutsData={shortcuts}
          selectedInterval={selectedInterval}
          cutoffDate={cutoffDate}
          tzOffset={tzOffset}
          setInterval={setInterval}
        />
        <CustomDateRangePicker
          value={value}
          isCustomSelected={isCustomSelected}
          setCustomSelected={setCustomSelected}
          cutoffDate={cutoffDate}
          tzOffset={tzOffset}
          setInterval={setInterval}
          containerRef={containerRef}
      />
      </DateContainer>

    </DateRange>
  );
};

export default DatePickerV2;
